<template>
  <div class="common-table">
    <a-card :bordered="false">
      <div class="table-page-search-wrapper">
        <a-form layout="inline">
          <a-row :gutter="10" type="flex">
            <a-col>
              <a-form-item label="Last Name">
                <a-input v-model="queryParam.lastName" @keyup.enter.stop="refreshCurrentPage" style="width:100px"/>
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item label="First Name">
                <a-input v-model="queryParam.firstName" @keyup.enter.stop="refreshCurrentPage" style="width:150px"/>
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item label="Email">
                <a-input v-model="queryParam.email" @keyup.enter.stop="refreshCurrentPage" style="width:200px"/>
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item label="Phone">
                <a-input v-model="queryParam.phone" @keyup.enter.stop="refreshCurrentPage" style="width:110px" @keypress="onlyNumber" />
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item
                style="width:155px;"
                label="DOB"
                :validateStatus="birthdayValid.status"
                :help="birthdayValid.help"
              >
                <a-input
                  v-model="queryParam.birthday"
                  placeholder="mm/dd/yyyy"
                  :maxLength="10"
                  @blur="handleCustomerBirthdayBlur"
                  @keyup.enter.stop="refreshCurrentPage"
                  @keypress="handleDateChange"
                />
              </a-form-item>
            </a-col>
            <a-col>
              <a-form-item label="ID">
                <a-input v-model="queryParam.cdbCode" @keyup.enter.stop="refreshCurrentPage" style="width:110px"/>
              </a-form-item>
            </a-col>
            <a-col>
              <span class="table-page-search-submitButtons" :style="advanced && { float: 'right', overflow: 'hidden' } || {} ">
                <a-button type="primary" @click="$refs.table.refresh(true)">Search</a-button>
                <a-button style="margin-left: 8px" @click="reset">Clear</a-button>
              </span>
            </a-col>
          </a-row>
        </a-form>
      </div>
    </a-card>
    <a-card :bordered="false">
      <div class="title-plate">
        <div class="btn-plate">
          <a-button type="primary" @click="handleEdit()" :disabled="!$auth('CDB_CUSTOMER_ADD')" v-show="!isMergeShow" style="margin-right:5px;">Add New</a-button>
          <a-button type="primary" @click="handleMerge()" :disabled="!$auth('CDB_CUSTOMER_ADD')" style="margin-right:5px;">{{ mergeList.length == 2 ? 'Proceed' : 'Merge' }}</a-button>
          <a-button @click="handleMergeCancel()" v-if = "isMergeShow">Cancel</a-button>
        </div>
        <div v-if="mergeList.length > 0" class="merge-list">
          <draggable v-model="mergeList">
            <template v-for="(item,index) in mergeList">
              <a-tag  :key="item.globalCode" closable @close="handleTagClose(item)" style="margin-left:5px" :color="index == 0 ? 'green' : 'red'">{{ item.globalCode + ' ' + item.fullName }}</a-tag>
            </template>
          </draggable>
        </div>
      </div>
      <s-table
        ref="table"
        size="default"
        rowKey="id"
        showQuickJumper
        :columns="columns"
        :data="loadData"
        style="display: table;"
      >
        <span slot="serial" slot-scope="text, record, index">
          <a-checkbox 
            :checked="selectRowCodes.includes(record.globalCode)" 
            @change="onCheckChange(record)" 
            :key="record.globalCode"
            v-if="isMergeShow"
          />
          <template v-else>
            {{ index + 1 }}
          </template>
          
        </span>
        <!-- signet -->
        <span slot="joinTourTotal" slot-scope="text, record">
          <span>{{ record.joinTourTotal}}<span v-if="record.signetCustomerCode">/</span>{{ record.joinTourCancelTotal}}</span>
        </span>
        <!-- supera -->
        <span slot="superaJoinTourTotal" slot-scope="text, record">
          <span>{{ record.superaJoinTourTotal}}<span v-if="record.superaCustomerCode">/</span>{{ record.superaJoinTourCancelTotal}}</span>
        </span>
        
        <div slot="writeDate" slot-scope="text, record">
          <a-tooltip placement="top">
            <template slot="title">
              <div style="font-weight:500;margin-right: 6px;">{{ record.changeBy.userName }}</div>
              <div>{{ DateTimeUtil().localString(record.writeDate !== null ? record.writeDate : record.createDate) }}</div>
            </template>
            <div>
              <div>
                {{ DateTimeUtil().utcString(record.writeDate !== null ? record.writeDate : record.createDate, 'MM/DD/YYYY') }}
              </div>
            </div>
          </a-tooltip>
        </div>

        <div slot="fullName" slot-scope="text">
          {{ text ? text.replace(/,/g, ', ') : '' }}
        </div>

        <span slot="action" slot-scope="text, record">
          <template>
            <a @click="handleEdit(record)" :disabled="!$auth('CDB_CUSTOMER_EDIT')"><a-icon type="edit" /></a>
            <a-divider type="vertical" />
            <a-popconfirm
              title="Are you sure delete?"
              @confirm="onDeleteConfirmed(record)"
              okText="Yes"
              cancelText="No"
            >
              <a href="javascript:;" :disabled="!$auth('CDB_CUSTOMER_DELETE')"><a-icon type="delete" style="color:#eb2f96;"/></a>
            </a-popconfirm>
          </template>
        </span>
      </s-table>
      <a-modal
        title="Merge To Other Customer"
        :visible="false"
        :destroyOnClose="true"
        :maskClosable="false"
        @cancel="handleMergeToCancel"
        :width="962"
      >
        <a-spin :spinning="loading">
          <a-form-model
            ref="mergeToForm"
            :model="mergeToForm"
            :rules="mergeToRules"
            class="cdb-customer-merge-to-modal"
          >
            <a-form-model-item label="Customer code" prop="targetCustomerCode">
              <a-input v-model="mergeToForm.targetCustomerCode" @change="handleCustomerCodeChange" />
            </a-form-model-item>
            <a-form-model-item label="" style="margin-left: 10px;">
              <a-button type="primary" @click="handleSearch">Search</a-button>
            </a-form-model-item>
          </a-form-model>
          <div class="common-table" v-if="dataList && dataList.length > 0">
            <a-table
              :columns="columns"
              :data-source="dataList"
              rowKey="id"
              :pagination="false"
              style="display: table;"
            >
              <span slot="serial" slot-scope="text, record, index">{{ index + 1 }}</span>
              <!-- signet -->
              <span slot="joinTourTotal" slot-scope="text, record">
                <span>{{ record.joinTourTotal}}<span v-if="record.signetCustomerCode">/</span>{{ record.joinTourCancelTotal}}</span>
              </span>
              <!-- supera -->
              <span slot="superaJoinTourTotal" slot-scope="text, record">
                <span>{{ record.superaJoinTourTotal}}<span v-if="record.superaCustomerCode">/</span>{{ record.superaJoinTourCancelTotal}}</span>
              </span>
              
              <div slot="writeDate" slot-scope="text, record">
                <a-tooltip placement="top">
                  <template slot="title">
                    <div style="font-weight:500;margin-right: 6px;">{{ record.changeBy.userName }}</div>
                    <div>{{ DateTimeUtil().localString(record.writeDate !== null ? record.writeDate : record.createDate) }}</div>
                  </template>
                  <div>
                    <div>
                      {{ DateTimeUtil().utcString(record.writeDate !== null ? record.writeDate : record.createDate, 'MM/DD/YYYY') }}
                    </div>
                  </div>
                </a-tooltip>
              </div>

              <div slot="fullName" slot-scope="text">
                {{ text ? text.replace(/,/g, ', ') : '' }}
              </div>
            </a-table>
          </div>
        </a-spin>
        <template slot="footer">
          <a-button type="primary" :loading="mergeToLoading || loading" @click="handleMergeToConfirm" :disabled="!dataList || dataList.length == 0">
            Save
          </a-button>
          <a-button @click="handleMergeToCancel">
            Close
          </a-button>
        </template>
      </a-modal>
    </a-card>
    <cdb-customer-merge-page ref="customerMergeComponent" v-if="showMergeModal" :mergeToRecord="mergeToRecord" :mergeData="dataList[0]" @close-change="handleMergeClose"></cdb-customer-merge-page>
  </div>
</template>

<script>
import '@/assets/css/common-table-list.css'
import moment from 'moment'
import STable from '@/components/table/'
import { toSTablePage } from '@/utils/util'
import CDBApi from '@/api/api-cdb-custome-v2'
import { Company } from '@/utils/helper/standard-code-utils'
import CdbCustomerMergePage from './components/CdbCustomerMergePage'
import draggable from 'vuedraggable'

export default {
  name: 'CdbCustomerList',
  components: {
    STable,
    CdbCustomerMergePage,
    draggable
  },
  data () {
    return {
      companyList: Company.dict,
      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: { lastName: '', firstName: '', email: '', phone: '', birthday: null, cdbCode: '' },
      // 表头
      columns: [
        {
          title: '#',
          scopedSlots: { customRender: 'serial' },
          width: '35px',
          align:'center'
        },
        {
          title: 'Number',
          dataIndex: 'globalCode',
          align:'center',
          width: '95px'
        },
        {
          title: 'Name',
          dataIndex: 'fullName',
          scopedSlots: { customRender: 'fullName' },
        },
        {
          title: 'Gender',
          dataIndex: 'gender',
          align:'center',
          width: '70px',
          customRender: (value) => (value === 'M') ? 'Male' : 'Female'
        },
        {
          title: 'DOB',
          dataIndex: 'birthday',
          width: '100px',
          align:'center',
          customRender: (value) => this.dateFormatB(value)
        },
        {
          title: 'Signet#',
          dataIndex: 'signetCustomerCode',
          align: 'center',
          width: '95px'
        },
        {
          title: 'Signet Join',
          dataIndex: 'joinTourTotal',
          align: 'center',
          width: '90px',
          scopedSlots: { customRender: 'joinTourTotal' }
        },
        {
          title: 'Supera#',
          dataIndex: 'superaCustomerCode',
          align: 'center',
          width: '95px'
        },
        {
          title: 'Supera Join',
          dataIndex: 'superaJoinTourTotal',
          align: 'center',
          width: '90px',
          scopedSlots: { customRender: 'superaJoinTourTotal' }
        },
        {
          title: 'Last Modified',
          dataIndex: 'writeDate',
          width: '110px',
          align: 'center',
          scopedSlots: { customRender: 'writeDate' }
        },
        {
          title: '',
          dataIndex: 'action',
          scopedSlots: { customRender: 'action' },
          align:'center'
        }
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        parameter.curPage = parameter.pageNo
        const queryParam = Object.assign({}, this.queryParam)
        if (queryParam.birthday) {
          queryParam.birthday = moment(queryParam.birthday, 'MM/DD/YYYY').format('YYYY-MM-DD')
        } else {
          delete queryParam.birthday
        }
        return CDBApi.query(Object.assign(parameter, queryParam))
          .then(res => {
            return toSTablePage(res.data)
          })
      },
      selectedRowKeys: [],
      selectedRows: [],
      // 合并团操作
      labelCol: { span: 7 },
      wrapperCol: { span: 12 },
      mergeToRecord: null,
      mergeToLoading: false,
      mergeToForm: { targetCustomerCode: null },
      mergeToRules: {
        targetCustomerCode: [{ required: true, message: 'Please input a customer code.' }],
      },
      // 客人生日是否有效,客人生日格式错误提示语
      birthdayValid: {
        status: 'success',
        help: ''
      },
      loading: false,
      dataList: [],
      isMergeShow: false,
      mergeList: [],
      selectRowCodes: [],
      showMergeModal: false,
    }
  },
  created () {
  },
  methods: {
    handleEdit (record) {
      this.$emit('onEdit', record)
    },
    // 点击确认删除按钮
    onDeleteConfirmed (recode) {
      const params = { 'ids': [recode.id] }
      const that = this
      CDBApi.delete(params).then(res => {
        if (!that.mixinProcessHasBizErrorNotification(res)) {
          that.mixinProcessSuccessNotification('Delete successfully !')
          that.$refs.table.refresh(true)
        }
      })
    },
    // 合并出团次数
    showMergeToModal (record) {
      this.mergeToRecord = record
      this.mergeToForm = { targetCustomerCode: null }
      this.dataList = []
    },
    handleCustomerCodeChange (e) {
      if (!e.target.value) {
        this.dataList = []
      }
    },
    handleSearch () {
      this.$refs.mergeToForm.validate(async (valid) => {
        if (valid) {
          this.loading = true
          try {
            const res = await CDBApi.query({ mergeCdbCode: this.mergeToForm.targetCustomerCode, pageNo: 1, pageSize: 1, curPage: 1 })
            this.dataList = res.data.datas || []
          } catch (e) {
            console.log('error', e)
          } finally {
            this.loading = false
          }
        }
      })
    },
    handleMergeToConfirm () { 
      //this.$refs.customerMergeComponent.isModalShow = true
      //this.$refs.customerMergeComponent.loadData()
    },
    handleDateChange (e) {
      const value = e.target.value
      if (value && value !== '') {
        let newValue = value.replace(/([^0-9|\\/])/, '')
        if (/^[0-9]{2}$/.test(newValue)) {
          newValue = newValue + '/'
        }
        if (/^[0-9]{2}\/[0-9]{2}$/.test(newValue)) {
          newValue = newValue + '/'
        }
        e.target.value = newValue
        this.queryParam.birthday = newValue
        this.$nextTick(() => {
          if (newValue.length === 10) {
            this.handleCustomerBirthdayBlur()
          }
        })
      }
    },
    handleCustomerBirthdayBlur () {
      const value = this.queryParam.birthday
      // 日期格式
      const DATE_REG = /^(((0?[13578]|1[02])\/(0?[1-9]|[12]\d|3[01])\/((1[6-9]|[2-9]\d)\d{2}))|((0?[13456789]|1[012])\/(0?[1-9]|[12]\d|30)\/((1[6-9]|[2-9]\d)\d{2}))|(0?2\/(0?[1-9]|1\d|2[0-8])\/((1[6-9]|[2-9]\d)\d{2}))|(0?2\/29\/((1[6-9]|[2-9]\d)(0[48]|[2468][048]|[13579][26])|((16|[2468][048]|[3579][26])00))))$/
      let valid = false
      if (!value || value.length === 0) {
        this.birthdayValid.status = 'success'
        this.birthdayValid.help = ''
        valid = false
      } else {
        if (DATE_REG.test(value)) {
          this.birthdayValid.status = 'success'
          this.birthdayValid.help = ''
          valid = true
        } else {
          this.birthdayValid.status = 'error'
          this.birthdayValid.help = 'Invalid date format!',
          valid = false
        }
      }
      return valid
    },
    handleMergeToCancel () {
      this.mergeToRecord = null
      this.mergeToForm = { targetCustomerCode: null }
    },
    //
    toggleAdvanced () {
      this.advanced = !this.advanced
    },
    refreshCurrentPage () {
      this.$refs.table.refresh()
    },
    // 重置查询条件
    reset () {
      this.queryParam = { lastName: '', firstName: '', email: '', phone: '', birthday: null, cdbCode: '' }
      this.refreshCurrentPage()
    },
    resetSearchForm () {
      this.queryParam = {
        date: moment(new Date())
      }
    },
    // 只允许输入数字
    onlyNumber (e) {
      if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Delete' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight' && e.key !== 'Tab') {
        e.preventDefault()
      }
    },
    //點擊merge按鈕
    handleMerge () {
      if (this.isMergeShow && this.mergeList.length > 1) {
        this.mergeToRecord = this.mergeList[0]
        this.dataList = [this.mergeList[1]]
        this.showMergeModal = true
        
      } 
      this.isMergeShow = true
    },
    //取消Merge
    handleMergeCancel () {
      this.isMergeShow = false
      this.mergeList = []
      this.selectRowCodes = []
    },
    //點擊選取合并用戶
    onCheckChange (e) {
      if (this.selectRowCodes.includes(e.globalCode)) {
        this.mergeList = this.mergeList.filter(item => item.id !== e.id)
        this.selectRowCodes = this.selectRowCodes.filter(item => item !== e.globalCode)
      } else {
        if (this.mergeList.length > 1) {
          this.$message.warn('Only two customers may be selected.')
          return
        }
        this.mergeList.push(e)
        this.selectRowCodes.push(e.globalCode)
      }
    },
    //標籤頁關閉
    handleTagClose (e) {
        this.mergeList = this.mergeList.filter(item => item.id !== e.id)
        this.selectRowCodes = this.selectRowCodes.filter(item => item !== e.globalCode)
    },
    //關閉合并窗口
    handleMergeClose (saveFlag) {
      this.showMergeModal = false
      this.mergeToRecord = null
      this.dataList = []
      if (saveFlag) {
        this.$refs.table.refresh(true)
        this.handleMergeCancel()
      }
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.currentComponet = 'List'
    }
  }
}
</script>
<style lang="less" scoped>
::v-deep .table-page-search-wrapper .ant-form-inline .ant-form-item > .ant-form-item-label {
  padding-right:0px;
}
.cdb-customer-merge-to-modal {
  display: flex !important;
  ::v-deep .ant-form-item {
    display: flex !important;
  }
}
.overflow-hidden{
  width: 100%;
  position: relative;
  text-align: left;
}
.overflow-hidden > div{
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  position: absolute;
  left: 0;
}
::v-deep .ant-table-tbody > tr > td {
  vertical-align: top;
}
</style>